import axios from 'axios';

const configuredApiUrl = import.meta.env.VITE_API_URL;
const isBrowser = typeof window !== 'undefined';
const isLocalhost = isBrowser && ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);
const isRootProductionHost = isBrowser && window.location.hostname === 'redexct.com';
const configuredAbsoluteApiUrl = configuredApiUrl?.startsWith('http') ? configuredApiUrl : undefined;
const configuredLocalApiUrl = configuredApiUrl && (
  configuredApiUrl.startsWith('/') ||
  configuredApiUrl.includes('localhost') ||
  configuredApiUrl.includes('127.0.0.1') ||
  configuredApiUrl.includes('::1')
) ? configuredApiUrl : undefined;
const apiBaseUrl = isBrowser && !isLocalhost
  ? (isRootProductionHost ? configuredAbsoluteApiUrl || 'https://www.redexct.com/api' : '/api')
  : configuredLocalApiUrl || 'http://localhost:3004/api';

// Create axios instance with base configuration for API calls
const api = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('redex_admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth on 401
      localStorage.removeItem('redex_admin_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;